







import { Component } from 'vue-property-decorator';
import AbstractDisplayField from './abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';
import moment from 'moment';

@Component({
  name: 'bpc-display-field-birthdate',
  components: {},
})
export default class DisplayFieldBirthdate extends mixins(AbstractDisplayField) {
  get formatDate(): string {
    if (this.value) {
      return moment(String(this.value)).format('DD/MM/YYYY');
    }
    return '';
  }

  get age(): string {
    if (this.value) {
      const birthDate = moment(String(this.value));
      const years = moment().diff(birthDate, 'years');

      if (years >= 1) {
        return years === 1
          ? `${years} ${this.$t('global.year')}`
          : `${years} ${this.$t('global.years')}`;
      } else {
        const months = moment().diff(birthDate, 'months');
        if (months >= 1) {
          return months === 1
            ? `${months} ${this.$t('global.month')}`
            : `${months} ${this.$t('global.months')}`;
        } else {
          return `0 ${this.$t('global.months')}`;
        }
      }
    }
    return '';
  }
}
